import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import BrandLogo from '../Assetes/Images/KFC-Logo-Red.png';
import Offcanvas from 'react-bootstrap/Offcanvas';
import SideCart from '../Views/Cart/SideCart';
import OrderOptions from '../Views/OrderOptions/OrderOptions';
import Avatar from '../Assetes/Images/avatar.jpg'
import SelectOption from './SelectOption';
import OrderType from './OrderType';
import Button from '@mui/material/Button';
import ChangeTheme from './ChangeTheme';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SattingScreen from '../Views/ProfileInfo/SattingScreen';
import { connect, useSelector } from 'react-redux';
import useTrackEvent from '../hooks/useTrackHook';
import GoBack from '../Views/BackButton/GoBack';
import { updatedKmlStore, updateOnlineDeliveryFee } from '../Redux';
import { savePaymentMethod } from '../Redux/actions/payment';
import mergn from 'mergn-webapp-sdk';
import LanguageSwitcher from "./LanguageSwitcher";
import useCurrentLocale from '../hooks/useLanguage';

function Header(props: any) {
  const payment_tax = useSelector((state: any) => state.payment.payment_tax);
  const cartData = useSelector((state: any) => state.cart.cartData);
  const cartQty = useSelector((state: any) => state.cart.cartQty);
  const [show, setShow] = useState(false);
  const [value, setValue] = useState(0);
  const location = useLocation();
  const [addEvent] = useTrackEvent();
  const storeSelected = useSelector((state: any) => state.store.storeSelected);
  const propsPosition: any = useSelector((state: any) => state.payment.position);
  const paymentMethod = useSelector((state: any) => state.payment.paymentMethod);
  const taxDataCash = useSelector((state: any) => state.store.taxDataCash);
  const taxDataCard = useSelector((state: any) => state.store.taxDataCard);
  const orderType = useSelector((state: any) => state.payment.orderType);
  const poseFee = useSelector((state: any) => state.store.pos_fee);
  const deliveryFee = useSelector((state: any) => state.store.deliveryfee);
  const lang = useCurrentLocale();

  useEffect(() => {
    props.updateOnlineDeliveryFee(0)
    cartData.forEach((item: any) => {
      if (paymentMethod !== "" && paymentMethod !== 'Cash' && payment_tax) {
        let originalPrice = item.selectedsize ? item.selectedsize.mrp * item.quantity : item.combo.combo_mrp_price * item.quantity;
        let totalModPrice = 0;
        if (item.modifiers) {
          Object.keys(item.modifiers).map((key: any) => {
            item.modifiers[key].map(
              (modItem: any, index: any) => {
                if (modItem.selected == true) {
                  if ((modItem.discount_price || modItem.discount_price == 0)) {
                    const originalPrice = modItem.discount_price;
                    totalModPrice += originalPrice;
                  } else {
                    const originalPrice = modItem.modifier_sale_price;
                    totalModPrice += originalPrice;
                  }
                }
              })
          })
        }
        item.totalItemPrice = originalPrice + totalModPrice;
        item.updateOnlineItemPrice = 0
      }
    })
    props.savePaymentMethod("")
    props.setValue && props.setValue(props.value + 1);
  }, [])

  useEffect(() => {
    setShow(false);
  }, [location]);

  const handleClose = () => {
    setShow(false);
  };

  const handleShow = () => setShow(true);
  const [showId, setShowId] = useState(window.innerWidth > 769);

  useEffect(() => {
    if (storeSelected) {
      if (paymentMethod && paymentMethod != "Cash") {
        props.updatedKmlStore(storeSelected.store_id, propsPosition, orderType, taxDataCard.tax_percent, poseFee, deliveryFee)
      } else {
        props.updatedKmlStore(storeSelected.store_id, propsPosition, orderType, taxDataCash.tax_percent, poseFee, deliveryFee)
      }
    }
    const handleResize = () => {
      setShowId(window.innerWidth > 500);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);
  useEffect(() => {
    // forcefully rerender
    setValue(value + 1)
  }, [props.headerUpdate])

  function eventsFired() {
    addEvent({ category: "events", events: "View Bucket" })
    mergn.recordEvent('Cart Click')
  }

  const isHomePage = location.pathname === `/${lang}`;
  const isMenuPage = location.pathname ===  `/${lang}/menu` ;
  const isDetailPage = location.pathname === `${lang}/details`;
  const isLoginPage = location.pathname === `/${lang}/login`;
  const isHomePageLang = location.pathname === '/' || location.pathname === `/${lang}`;
  return (
    <>
      <div>
        <Navbar className="main-header header-color">
          <div className="container-xxl category-container-custom">
            <div className="d-flex align-items-center">
              <button onClick={handleShow} className="burgur-btn">
                <i className="ri-menu-2-line"></i>
              </button>
              <div className="header-login">
                <Link to={`/${lang}`}>
                  <img
                    src={BrandLogo}
                    className="brand-logo"
                    alt="brand-logo"
                  />
                </Link>
              </div>
              <div className="order-through">
                <OrderOptions />
              </div>
            </div>
            <Navbar.Toggle />
            <div className="mobile-ckeck">
              <OrderType />
            </div>

            <div className="d-flex gap-2 align-items-center">
              <Link
                to={`/${lang}/bucket`}
                className="item-card-header"
                id={showId ? "cart" : " "}
              >
                <div className="item-card-item" id="">
                  <button
                    onClick={() => eventsFired()}
                    className="fly-cart-btn"
                  >
                    {storeSelected ? cartQty : 0}
                  </button>
                  <ul />
                </div>
              </Link>
              <div className="header-login">
                {isHomePageLang && <LanguageSwitcher />}
              </div>
              <div className="d-none">
                <ChangeTheme />
              </div>
              <Offcanvas show={show} onHide={handleClose}  placement={lang === 'ar' ? 'end' : 'start'}>
                <Offcanvas.Header className="menu-close"></Offcanvas.Header>
                <SideCart />
              </Offcanvas>
              <div className="header-login">
                <SattingScreen />
              </div>
              <div className="header-logo-mobile">
                <Link to={`/${lang}`}>
                  <img
                    src={BrandLogo}
                    className="brand-logo"
                    alt="brand-logo"
                  />
                </Link>
              </div>
            </div>
          </div>
        </Navbar>
        <div className="order-mobile ">
          <div className="backbtn-mobile">
            {!isMenuPage && !isHomePage && !isDetailPage && !isLoginPage && (
              <GoBack />
            )}
          </div>
          <OrderOptions />
        </div>

        <Link to={`/${lang}/bucket`} className="" id={showId ? " " : "cart"}>
          <div className="item-card-item " id="">
            <button
              className="fly-cart-btn cart-basket-sticky"
              onClick={() => eventsFired()}
            >
              {storeSelected ? cartQty : 0}
            </button>
          </div>
        </Link>
      </div>
      <div className="extra-mian"></div>
    </>
  );
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    updatedKmlStore: (store_id: any, position: any, orderType: any, tax_percent: any, pos_fee: any, delivery_fee: any) => {
      dispatch(updatedKmlStore(store_id, position, orderType, tax_percent, pos_fee, delivery_fee));
    },
    savePaymentMethod: function (payment_method: any) {
      dispatch(savePaymentMethod(payment_method));
    },
    updateOnlineDeliveryFee: function (delivery_fee: any) {
      dispatch(updateOnlineDeliveryFee(delivery_fee));
    }
  };
};

export default connect(null, mapDispatchToProps)(Header);